module.exports = [
  '$resource',
  function AppointmentReasonResource(
    $resource,
  ) {
    const ResourceObject = $resource('/api/v2/appointments/reasons/:id',
      {
        id: '@id',
      },
      {
        query: {
          method: 'get',
          url: '/api/v2/groups/:group_id/appointments/reasons',
          isArray: true,
        },
        get: {
          method: 'get',
        },
      },
    );

    angular.extend(ResourceObject.prototype, {
      $hasPreferences() {
        return this.allowTimePreference || this.allowSelectHcp || (this.visitReasonType && this.visitReasonType !== 'nothing');
      },
    });

    return ResourceObject;
  },
];



// WEBPACK FOOTER //
// ./main/factories/appointment-reason-resource.js